module.exports = __webpack_public_path__ + "img/d00c213.png";